var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankDebit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_transaction_debit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 17.4716147,
    cy: 17.4520552,
    rx: 17.4716147,
    ry: 17.4520552
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.5%",
    y: "-20.1%",
    width: "163.0%",
    height: "163.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.192156863   0 0 0 0 0.239215686  0 0 0 0.08 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.192156863   0 0 0 0 0.239215686  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recent_Transactions",
    transform: "translate(-5.000000, -273.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_transaction_debit",
    transform: "translate(11.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.1238882,8.81662509 C17.3374766,8.68640198 17.6061209,8.68640198 17.8197092,8.81662509 L25.2589053,13.349423 C25.4089199,13.4408135 25.5004354,13.6035617 25.5004354,13.7789654 L25.5004354,14.3962031 C25.5004354,14.4850282 25.4650593,14.5702112 25.4021149,14.6330106 C25.3391704,14.6958101 25.2538057,14.731081 25.1648022,14.7310633 L24.1623182,14.7310633 C23.9775627,14.7310633 23.8277889,14.8805369 23.8277889,15.0649219 L23.8277889,21.1352052 C23.8278188,21.2515425 23.8885284,21.359475 23.9880284,21.4200867 L25.2589053,22.1943382 C25.4089195,22.2857131 25.5004354,22.448452 25.5004354,22.6238472 L25.5004354,23.7417727 C25.5004354,23.8306274 25.4650498,23.9158393 25.4020875,23.9786628 C25.3391252,24.0414863 25.253735,24.0767664 25.1647018,24.0767664 L9.77739027,24.0767664 C9.59263483,24.0767664 9.44279404,23.9272928 9.44279404,23.7429078 L9.44279404,22.6231461 C9.44279404,22.4482152 9.53412459,22.2859039 9.68372206,22.1947388 L10.9553014,21.4199532 C11.0547718,21.3593575 11.115448,21.2514422 11.1154406,21.1351385 L11.1154406,15.0648885 C11.1154406,14.8805035 10.9656668,14.7310299 10.7809113,14.7310299 L9.77732336,14.7310299 C9.59256792,14.7310299 9.44279404,14.5815563 9.44279404,14.3971713 L9.44279404,13.7781308 C9.44279404,13.603227 9.53406385,13.4409467 9.68365515,13.3498236 L17.1238882,8.81662509 Z M20.1480333,21.0701028 C20.1480333,21.2544878 20.2978072,21.4039614 20.4825626,21.4039614 L21.8206799,21.4039614 C22.0054353,21.4039614 22.1552092,21.2544878 22.1552092,21.0701028 L22.1552092,15.0648885 C22.1552092,14.8805035 22.0054353,14.7310299 21.8206799,14.7310299 L20.4825626,14.7310299 C20.2978072,14.7310299 20.1480333,14.8805035 20.1480333,15.0648885 L20.1480333,21.0701028 Z M16.4682108,21.0701028 C16.4682108,21.2544878 16.6179847,21.4039614 16.8027401,21.4039614 L18.1408574,21.4039614 C18.3256128,21.4039614 18.4753867,21.2544878 18.4753867,21.0701028 L18.4753867,15.0648885 C18.4753867,14.8805035 18.3256128,14.7310299 18.1408574,14.7310299 L16.8027401,14.7310299 C16.6179847,14.7310299 16.4682108,14.8805035 16.4682108,15.0648885 L16.4682108,21.0701028 Z M17.4717987,13.0595669 C18.0259052,13.0594379 18.4750045,12.6110647 18.4749183,12.0580692 C18.4748321,11.5050737 18.025593,11.0568399 17.4714865,11.0568829 C16.91738,11.0569259 16.4682108,11.5052294 16.4682108,12.0582249 C16.4683032,12.6112617 16.917584,13.0595221 17.4717318,13.0594668 L17.4717987,13.0595669 Z M12.7883883,21.0701028 C12.7883883,21.2544878 12.9381622,21.4039614 13.1229176,21.4039614 L14.4610349,21.4039614 C14.6457903,21.4039614 14.7955642,21.2544878 14.7955642,21.0701028 L14.7955642,15.0648885 C14.7955642,14.8805035 14.6457903,14.7310299 14.4610349,14.7310299 L13.1229176,14.7310299 C12.9381622,14.7310299 12.7883883,14.8805035 12.7883883,15.0648885 L12.7883883,21.0701028 Z",
    id: "Bank-Copy-2",
    fill: "#A8BCF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-3",
    fill: "#6084E4",
    cx: 23.7613961,
    cy: 23.7347951,
    rx: 4.19318754,
    ry: 4.18849325
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5746597,25.7567414 C24.475455,25.85306 24.3145159,25.8531538 24.215192,25.7569507 C24.1158681,25.6607476 24.1157714,25.5046779 24.2149761,25.4083592 L25.690715,23.9790074 L21.2199156,23.9790074 C21.0796475,23.9790074 20.9659377,23.8687381 20.9659377,23.7327139 C20.9659377,23.5966898 21.0796475,23.4864205 21.2199156,23.4864205 L25.6864101,23.4864205 L24.2149761,22.061231 C24.1157714,21.9649123 24.1158681,21.8088426 24.215192,21.7126395 C24.3145159,21.6164364 24.475455,21.6165302 24.5746597,21.7128489 L26.4823389,23.5606041 C26.530045,23.6067707 26.5568544,23.6694438 26.5568544,23.7348013 C26.5568544,23.8001587 26.530045,23.8628318 26.4823389,23.9089985 L24.5746597,25.7567414 Z",
    id: "Shape-Copy-3",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDebit);
export default __webpack_public_path__ + "static/media/bank-debit.58bc259461bdd6c3f711c385117c7bd6.svg";
export { ForwardRef as ReactComponent };